import React from 'react';
import EditorUndo from '@wix/da-ds/pkg/Icons/24x24/EditorUndo';
import { ButtonProps } from './types';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';

const Undo: React.FC<ButtonProps> = ({ editor, hideWhenNotEnabled = true }) => {
  const { t } = useTranslation('editor');
  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'history'))
  ) {
    return null;
  }
  return (
    <EditorIconButton
      featureId="action:undo"
      icon={EditorUndo}
      onClick={() => editor.chain().focus().undo().run()}
      tooltipText={t('button.undo.tooltip')}
      aria-label={t('button.undo.tooltip')}
    />
  );
};
Undo.displayName = 'Undo';

export default Undo;
